
import { setMenusone, getMenusone } from '@/utils/auth'
import store from '../utils/storage'
export default {
  state: {
    isCollapse: false,
    currentMenu: null,
    menu: [],
    tab: [],
    tabsList: [
      {
        path: '/',
        name: 'home',
        label: '个人认证',
        icon: 'home'
      }
    ]
  },
  mutations: {
    setMenu (state, val) {
      // vuex添加
      state.menu = val
      // cookie也添加
      setMenusone(val)
    },
    clearMenu (state) {
      // 清除也一样 vuex和cookie都清除
      state.menu = []
      setMenusone('')
    },
    addMenu (state, router) {
      if (!getMenusone()) {
        return
      }
      // 取出cookie数据 给vuex
      let menu = getMenusone()
      state.menu = menu
      // 添加动态路由 主路由为Main.vue
      // let currentMenu = [
      //   {
      //     path: '/',
      //     component: () => import(`@/views/layout`),
      //     children: []
      //   }
      // ]
      // // 如果是一级菜单 那么菜单名称肯定有路由 如果是二级菜单那么一级没有 二级有路由
      // menu.forEach(item => {
      //   if (item.children) {
      //     item.children = item.children.map(item => {
      //       item.component = () => import(`@/views/${item.url}`)
      //       return item
      //     })
      //     currentMenu[0].children.push(...item.children)
      //   } else {
      //     item.component = () => import(`@/views/${item.url}`)
      //     currentMenu[0].children.push(item)
      //   }
      // })
      // // 添加动态路由
      // router.addRoutes(currentMenu)
    },
    // 选择标签 选择面包屑
    selectMenu (state, val) {
      // if (val.name !== 'home') {
      state.currentMenu = val
      let result = state.tabsList.findIndex(item => item.name === val.name)
      state.tabsList[0] = result === -1 ? val : ''
      store.set('tagList', JSON.stringify(state.tabsList))
      // } else {
      //   state.currentMenu = {
      //     path: '/',
      //     name: 'login',
      //     label: '个人认证',
      //     component: () => import('@/views/personal'),
      //     meta: { title: '个人认证' }

      //   }
      // }
      // val.name === 'home' ? (state.currentMenu = null) : (state.currentMenu = val)
    },
    // 获取标签
    getMenu (state) {
      if (store.get('tagList')) {
        let tagList = store.get('tagList')
        state.tabsList = tagList
      }
    },
    // 关闭标签
    closeTab (state, val) {
      let result = state.tabsList.findIndex(item => item.name === val.name)
      state.tabsList.splice(result, 1)
      store.set('tagList', JSON.stringify(state.tabsList))
    },
    // 左侧栏是否水平展开
    collapseMenu (state) {
      state.isCollapse = !state.isCollapse
    }
  },
  actions: {}
}



// WEBPACK FOOTER //
// ./src/store/tab.js